const RTL_LANGUAGES = ["ar", "he", "ur", "fa", "ku"];

export function languageDirection(language) {
  const lang = language?.split("-")[0];
  return lang && RTL_LANGUAGES.includes(lang) ? "rtl" : "ltr";
}
